import ApiService from '@/common/api.service';

export const SystemAndPolicyService = {
    query(country, params) {
        return ApiService.query(`/system-and-policy/${country}`, params)
    }
};
